module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "titlepage",
      "id": "titlepage"
    }
  }, [_c('div', {
    staticClass: "ipadfp"
  }, [_c('span', {
    attrs: {
      "aria-label": "page i",
      "epub:type": "pagebreak",
      "id": "page_i",
      "role": "doc-pagebreak"
    }
  }, [_c('img', {
    staticClass: "imagefp",
    attrs: {
      "alt": "Cold Cases: A True Crime Collection, by Cheyna Roth, Ulysses Press",
      "src": "e9781646041145/images/title.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3efbec53","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781646041145/xhtml/title.vue
// module id = 60
// module chunks = 0